import FullScreen from "src/atoms/FullScreen";
import LoginEnhanced from "./LoginEnhanced";
import { useNavigate } from "react-router-dom";

export default function LoginAsRoute() {
  const navigate = useNavigate();
  return (
    <FullScreen>
      <LoginEnhanced
        mode="fullScreen"
        onBack={() => navigate(-1)}
        onSuccess={() => navigate("/dashboard")}
      />
    </FullScreen>
  );
}
